import { call, put, takeEvery } from 'redux-saga/effects';
import { getModulesStructure } from '../../requests/get_modules_structure_request';
import { getGroupPermissions } from '../../requests/get_permissions_request';
import { getModulesStructureSuccess, getModulesStructureFailure } from '../actions/get_modules_structure.actions';
import { GET_MODULES_STRUCTURE_REQUEST } from '../constants/get_group_data.constants';
import { message_error } from '../../../../../components/Message';

function* getModulesStructureRequest({ id }) {
    const modulesStructure = yield call(getModulesStructure);
    const permissionsStructure = yield call(getGroupPermissions, id);
    if (modulesStructure.result && permissionsStructure.result) {
        const mergedData = modulesStructure.options.modules.map((module) => {
            permissionsStructure.options.forEach(permission => module.URL === permission.url && Object.assign(module, { modulePermissions: permission }));
            return module;
        });
        yield put(getModulesStructureSuccess({ mergedData, id }));
    } else {
        yield put(getModulesStructureFailure(modulesStructure.error || permissionsStructure.error));
        message_error('Something gone wrong!');
    }
}

export default function* getModulesStructureSaga() {
    yield takeEvery(GET_MODULES_STRUCTURE_REQUEST, getModulesStructureRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/sagas/get_modules_structure.saga.js